module.exports = __webpack_public_path__ + "img/111029.5c779d57.png";